"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertRole = exports.isRole = exports.Role = void 0;
var Role;
(function (Role) {
    Role["Admin"] = "ADMIN";
    Role["Icono"] = "ICONO";
    Role["Maquettiste"] = "MAQUETTISTE";
    Role["Nl"] = "NL";
    Role["NlAdmin"] = "ADMIN_NL";
    Role["PhotoAdminCuisine"] = "ADMIN_PHOTO_CUISINE";
    Role["Pigiste"] = "PIGISTE";
    Role["ReadOnly"] = "READ_ONLY";
    Role["Redacteur"] = "REDACTEUR";
    Role["SR"] = "SR";
    Role["Superadmin"] = "SUPERADMIN";
    Role["Validateur"] = "VALIDATEUR";
    Role["Web"] = "WEB";
    Role["WebAdmin"] = "ADMIN_WEB";
})(Role = exports.Role || (exports.Role = {}));
function isRole(maybeRole) {
    return Object.entries(Role).some(([, role]) => role === maybeRole);
}
exports.isRole = isRole;
function assertRole(maybeRole) {
    if (!isRole(maybeRole)) {
        throw new Error(`The role "${maybeRole}" does not exist.`);
    }
    return maybeRole;
}
exports.assertRole = assertRole;
//# sourceMappingURL=Role.js.map